import { render } from "./Forgotpassword.vue?vue&type=template&id=00d0a3a3&scoped=true"
import script from "./Forgotpassword.vue?vue&type=script&lang=js"
export * from "./Forgotpassword.vue?vue&type=script&lang=js"

import "./Forgotpassword.vue?vue&type=style&index=0&id=00d0a3a3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00d0a3a3"]])

export default __exports__